// ============================================================================
// NOTIFICATIONS ENDPOINTS
// ============================================================================
// In-app notification inbox proxy on CRS API:
// Backend controller: crs.Api.Controllers.NotificationModule.NotificationsController
// (route: [Route("api/v1/notifications")]).
// Inbox endpoints forward the caller's JWT to notifications-hub-api.

import { buildEndpoint, buildEndpointWithQuery } from './base.endpoints';
import type { ID, NotificationInboxParams } from '../types';

const BASE_PATH = '/notifications';

export const notificationsEndpoints = {
  /** GET /notifications/inbox/access — role-gated subscription check */
  access: () => buildEndpoint(`${BASE_PATH}/inbox/access`),

  /** GET /notifications/inbox */
  inbox: (params?: NotificationInboxParams) =>
    params
      ? buildEndpointWithQuery(`${BASE_PATH}/inbox`, params as Record<string, any>)
      : buildEndpoint(`${BASE_PATH}/inbox`),

  /** GET /notifications/inbox/unread-count */
  unreadCount: () => buildEndpoint(`${BASE_PATH}/inbox/unread-count`),

  /** POST /notifications/inbox/mark-read */
  markRead: () => buildEndpoint(`${BASE_PATH}/inbox/mark-read`),

  /** POST /notifications/inbox/{channelId}/archive */
  archive: (channelId: ID) =>
    buildEndpoint(`${BASE_PATH}/inbox/${channelId}/archive`),
} as const;

export default notificationsEndpoints;
